import { Reveal, Overline } from "@/components/Reveal";
import { BOARD, TEAM } from "@/data/content";

const PersonCard = ({ p, large = false, testId }) => (
  <div className="group" data-testid={testId}>
    <div className={`relative overflow-hidden rounded-[2rem] ${large ? "aspect-[4/5]" : "aspect-square"}`}>
      <img
        src={p.img}
        alt={`Portrait of ${p.name}`}
        className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-[filter,transform] duration-700"
      />
      <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0B132B]/85 to-transparent p-6 pt-16 translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
        <p className="font-display font-semibold text-xl text-white">{p.name}</p>
        <p className="text-[#FFB323] text-sm font-semibold">{p.title}</p>
      </div>
    </div>
    <p className="mt-4 text-sm text-[#4A5568] leading-relaxed">{p.bio}</p>
  </div>
);

export default function Team() {
  return (
    <main data-testid="team-page">
      <section className="bg-[#0B132B] text-white pt-40 pb-24 md:pb-32 grain relative overflow-hidden" data-testid="team-hero">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative z-10">
          <Reveal>
            <Overline light>Board & Team</Overline>
            <h1 className="font-display font-semibold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.08] max-w-4xl">
              Led by people with lived culturally diverse experience — because credibility starts with understanding.
            </h1>
            <p className="text-white/70 max-w-2xl mt-8 text-lg leading-relaxed">
              Our board and team bring together lived migrant journeys, senior corporate expertise
              and deep community roots. Many of us were once the students we now serve.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32" data-testid="team-leadership-section">
        <Reveal>
          <Overline>Leadership</Overline>
          <h2 className="font-display font-semibold text-3xl md:text-5xl tracking-tight text-[#0B132B] mb-4">
            Board of Directors
          </h2>
          <p className="text-[#4A5568] max-w-xl mb-16">
            Titles and bios below are placeholders — real details will be added shortly.
          </p>
        </Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
          {BOARD.slice(0, 3).map((p, i) => (
            <Reveal key={p.name} delay={i * 0.1}>
              <PersonCard p={p} testId={`board-card-${i}`} />
            </Reveal>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {BOARD.slice(3).map((p, i) => (
            <Reveal key={p.name} delay={i * 0.1}>
              <PersonCard p={p} testId={`board-card-${i + 3}`} />
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-white py-24 md:py-32" data-testid="team-staff-section">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <Reveal>
            <Overline>Team & Mentors</Overline>
            <h2 className="font-display font-semibold text-3xl md:text-5xl tracking-tight text-[#0B132B] mb-16">
              The people in the room, every week.
            </h2>
          </Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-8">
            {TEAM.slice(0, 3).map((p, i) => (
              <Reveal key={p.name} delay={i * 0.1}>
                <PersonCard p={p} testId={`team-card-${i}`} />
              </Reveal>
            ))}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {TEAM.slice(3).map((p, i) => (
              <Reveal key={p.name} delay={i * 0.1}>
                <PersonCard p={p} testId={`team-card-${i + 3}`} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
